<template>
  <v-layout>
    <v-flex>
      <v-sheet height="400">
        <!-- now is normally calculated by itself, but to keep the calendar in this date range to view events -->
        <v-calendar
          ref="calendar"
          :now="today"
          :value="today"
          color="primary"
          type="week"
        >
          <!-- the events at the top (all-day) -->
          <template
            slot="dayHeader"
            slot-scope="{ date }"
          >
            <template v-for="event in eventsMap[date]">
              <!-- all day events don't have time -->
              <div
                v-if="!event.time"
                :key="event.title"
                class="my-event"
                @click="open(event)"
                v-html="event.title"
              ></div>
            </template>
          </template>
          <!-- the events at the bottom (timed) -->
          <template
            slot="dayBody"
            slot-scope="{ date, timeToY, minutesToPixels }"
          >
            <template v-for="event in eventsMap[date]">
              <!-- timed events -->
              <div
                v-if="event.time"
                :key="event.title"
                :style="{ top: timeToY(event.time) + 'px', height: minutesToPixels(event.duration) + 'px' }"
                class="my-event with-time"
                @click="open(event)"
                v-html="event.title"
              ></div>
            </template>
          </template>
        </v-calendar>
      </v-sheet>
    </v-flex>
  </v-layout>
</template>

<script>
  import moment from 'moment'
  import { mapActions, mapGetters } from 'vuex'
  export default {
    data: () => ({
      today: moment().format('YYYY-MM-DD'),
      events: []
      // events: [
      //   {
      //     title: 'João da Silva',
      //     date: moment().format('YYYY-MM-DD'),
      //     time: '09:00',
      //     duration: 45
      //   },
      //   {
      //     title: 'Reunião',
      //     date: moment().add(3, 'day').format('YYYY-MM-DD')
      //   },
      //   {
      //     title: 'Alexandre Campagnaro',
      //     date: moment().add(1, 'day').format('YYYY-MM-DD'),
      //     time: '12:30',
      //     duration: 180
      //   }
      // ]
    }),
    computed: {
      // convert the list of events into a map of lists keyed by date
      eventsMap () {
        const map = {}
        this.events.forEach(e => (map[e.date] = map[e.date] || []).push(e))
        return map
      },
      ...mapGetters({
        customer: 'customer',
        auth: 'auth'
      }),
      ...mapGetters('schedule', ['getList', 'getAvailableAppointments', 'getAppointments']),
      ...mapGetters('app', ['getTheme', 'getDevice'])
    },
    mounted () {
      // this.$refs.calendar.locale = 'pt-br'
      this.$refs.calendar.scrollToTime(moment().format('LT'))
      this.setList({date: moment('2019-02-07').format('YYYY-MM-DD'), doctor: this.auth.auth.myClinic.crm}).then(() => {
        this.getList.map((item) => {
          this.events.push({
            title: item.title + ' ' + item.subtitle,
            date: moment('07/03/2019', 'DD/MM/YYYY').format('YYYY-MM-DD'),
            time: item.subtitle,
            duration: 40 // item.interval
          })
        })
      })
    },
    methods: {
      ...mapActions('schedule', ['setList', 'setAvailableAppointments', 'setLockAppointments', 'setUnlockAppointments']),
      open (event) {
        alert(event.title)
      }
    }
  }
</script>

<style lang="stylus" scoped>
  .my-event {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    border-radius: 2px;
    background-color: #1867c0;
    color: #ffffff;
    border: 1px solid #1867c0;
    font-size: 12px;
    padding: 3px;
    cursor: pointer;
    margin-bottom: 1px;
    left: 4px;
    margin-right: 8px;
    position: relative;

    &.with-time {
      position: absolute;
      right: 4px;
      margin-right: 0px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/schedule/week.vue